const BREAKPOINTS = '@breakpoints';
const LOCALES = '@locales';
const RENDER = '@render';
export { BREAKPOINTS, LOCALES, RENDER, };
//# sourceMappingURL=types.js.map